import { render, staticRenderFns } from "./LandingPageEditor.vue?vue&type=template&id=789794f7&scoped=true&lang=pug&"
import script from "./LandingPageEditor.vue?vue&type=script&lang=js&"
export * from "./LandingPageEditor.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageEditor.vue?vue&type=style&index=0&id=789794f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789794f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
